import axios from 'axios';
export default {
  data: () => ({
    logTypes: {
      FAILED_ACTIVATION_VALIDATION: 1,
      FAILED_ACTIVATION_INCORRECT_CARD_NUMBER: 2,
      FAILED_ACTIVATION_INCORRECT_CARD_WITHOUT_USER: 3,
      FAILED_ACTIVATION_INCORRECT_VERIFICATION_CODE: 4,
      FAILED_ACTIVATION_USER_ALREADY_REGISTERED: 5,
      FAILED_ACTIVATION_USER_NOT_EXIST: 6,
      FAILED_ACTIVATION: 7,
      PASSED_ACTIVATION: 8,
      FAILED_REGISTRATION_VALIDATION: 9,
      FAILED_REGISTRATION_MATCHING_ERROR: 10,
      FAILED_REGISTRATION_USER_ALREADY_REGISTERED: 11,
      FAILED_REGISTRATION_QUERY_EXCEPTION: 12,
      FAILED_REGISTRATION_INVALID_SIGNATURE: 13,
      FAILED_REGISTRATION: 14,
      PASSED_REGISTRATION: 15,
    }
  }),
  methods: {
    async addUserLog(type, user, card, vars, encrypted = false) {
      await axios.post(process.env.VUE_APP_LARAVEL_ENDPOINT + "/api/log/user", {
        type: type,
        user: user,
        card: card,
        vars: vars,
        user_encrypted: encrypted
      }).catch((error) => {
        if (error.response)
          if (error.response) {
            this.errors.push(error.response.data.message);
          }
        else {
          this.errors.push(error)
        } else this.errors.push("Nieznany błąd");
      })
    }
  }
}
